import * as ghl from './ghl'
 
 const ReqMethods = {
  GET: "get" as const,
  POST: "post" as const,
  PUT: "put" as const,
  DELETE: "delete" as const,
};

 const ResponseStatus = {
  SUCCESS: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_ERROR: 500,
};

 const Environment = {
  DEVELOPMENT: "development",
  STAGING: "staging",
  PRODUCTION: "production",
};

export { 
  Environment,
  ReqMethods,
  ResponseStatus,
  ghl
}